import(/* webpackMode: "eager" */ "/home/node/app/src/app/[locale]/(manual)/guide/[slug]/loading.tsx");
